<div class="explorer-notes-part">
	<grid-content [setup]="setup()" [namedSize]="'CustomHeight'" [customHeight]="service().explorer.customGridHeight()" [rows]="notes()"></grid-content>
</div>